import { render } from "./index.vue?vue&type=template&id=6e2ce139"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/organisms/test-push/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e2ce139"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e2ce139', __exports__)) {
    api.reload('6e2ce139', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6e2ce139", () => {
    api.rerender('6e2ce139', render)
  })

}


export default __exports__